var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5711 11.9137V17.6123C37.5711 17.8637 37.4035 18.1989 37.1521 18.2828L26.0901 24.4004C25.8387 24.568 25.5873 24.568 25.3358 24.4004L14.2739 18.2828C14.0225 18.1151 13.8549 17.8637 13.8549 17.6123V11.9137C13.8549 11.6623 14.0225 11.3271 14.2739 11.2433L25.3358 5.1257C25.5873 4.9581 25.8387 4.9581 26.0901 5.1257L37.1521 11.2433C37.4035 11.4109 37.5711 11.6623 37.5711 11.9137Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5253 11.8299L25.3359 17.8637C25.5873 18.0313 25.8387 18.0313 26.0901 17.8637L36.9007 11.8299",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7548 23.9813V18.0313",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5711 22.7243V28.4229C37.5711 28.6743 37.4035 29.0095 37.1521 29.0933L26.0901 35.2109C25.8387 35.3785 25.5873 35.3785 25.3358 35.2109L14.2739 29.0933C14.0225 28.9257 13.8549 28.6743 13.8549 28.4229V22.7243C13.8549 22.4729 14.0225 22.1377 14.2739 22.0539L25.3358 15.9363C25.5873 15.7687 25.8387 15.7687 26.0901 15.9363L37.1521 22.0539C37.4035 22.2215 37.5711 22.4729 37.5711 22.7243Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5253 22.6405L25.3359 28.6743C25.5873 28.8419 25.8387 28.8419 26.0901 28.6743L36.9007 22.6405",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7548 34.7919V28.8419",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5711 33.5349V39.2335C37.5711 39.4849 37.4035 39.8201 37.1521 39.9039L26.0901 46.0215C25.8387 46.1891 25.5873 46.1891 25.3358 46.0215L14.2739 39.9039C14.0225 39.7363 13.8549 39.4849 13.8549 39.2335V33.5349C13.8549 33.2835 14.0225 32.9483 14.2739 32.8645L25.3358 26.7469C25.5873 26.5792 25.8387 26.5792 26.0901 26.7469L37.1521 32.8645C37.4035 33.0321 37.5711 33.2835 37.5711 33.5349Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5253 33.5349L25.3359 39.5687C25.5873 39.7363 25.8387 39.7363 26.0901 39.5687L36.9007 33.5349",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7548 45.6025V39.6525",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.d44eb864a82ae4ae1d648f1da11fa3c4.svg";
export { ForwardRef as ReactComponent };